import { useAuth } from '@simplifi/auth'
import Axios from 'axios'

const api = Axios.create()

export function configureApiService() {
  api.interceptors.request.use(async (config) => {
    config.baseURL = import.meta.env.VITE_APP_API_BASE_URI
    return config
  })

  api.interceptors.request.use(async (config) => {
    if (config.headers && !config.headers.Authorization) {
      config.headers.Authorization = `bearer ${await useAuth().getToken()}`
    }
    return config
  })

  return api
}

export default api
